import {
  CompetitionApi,
  ICounterMatchApi,
  ISoccerMatchApi,
} from '@/app/pages/sports/football/home/models';
import { FsApiService } from '@/app/services/auth/fs-api.service';
import { CalendarService } from '@/app/services/calendar.service';
import { FavoritesService } from '@/app/services/favorite';
import { TranslationService } from '@/app/services/translation.service';
import { computed, inject, Injectable, signal } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { EStateMatches } from '../../sports/football/home/services';

const PAGE_SIZE = 10;
const defaultValues: ICounterMatchApi = {
  TotalMatches: 0,
  LiveMatches: 0,
  FinishedMatches: 0,
  NextMatches: 0,
};

@Injectable({
  providedIn: 'root',
})
export class CompetitionFavoritesMatchesByDayService {
  private fsApi = inject(FsApiService);
  private translateService = inject(TranslationService);
  private favoritesService = inject(FavoritesService);

  counterMatches = signal<ICounterMatchApi>(defaultValues);
  soccerMatches = signal<CompetitionApi[]>([]);
  paginationMatches = signal<number>(0);
  totoalPageMatches = signal<number>(1);
  isLoadingSoccerMatches = signal<boolean>(false);
  isErrorSoccerMatches = signal<boolean>(false);

  calendarService = inject(CalendarService);
  selectedDate = computed(() =>
    this.calendarService.selectedDate().replaceAll('-', '')
  );

  statusTapOption = signal<EStateMatches>(EStateMatches.ALL);

  isMoreMatches = computed(
    () => this.paginationMatches() < this.totoalPageMatches()
  );

  constructor() {}

  getCompetitionMatchesFavorites(page: number = 1) {
    if (page == 1) this.soccerMatches.set([]);

    const language = this.translateService.getLangLocalStorage();
    // formateDay = YYYYMMDD
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.isErrorSoccerMatches.set(false);

    this.isLoadingSoccerMatches.set(true);
    this.fsApi
      .get<ISoccerMatchApi>(
        `/matches/competitions/favorites/${this.selectedDate()}`,
        {
          // .get<ISoccerMatchApi>(`/matches/scheduled/${this.selectedDate()}`, {
          params: {
            size: PAGE_SIZE,
            page,
            timezone,
            language,
          },
        }
      )
      .pipe(
        map((data) => {
          const { Competitions, ...rest } = data as ISoccerMatchApi;
          return {
            ...rest,
            Competitions:
              Competitions === null
                ? []
                : Competitions.map((item) => {
                    // add favorite local
                    this.favoritesService.checkFavoriteCompetition(
                      item.Id,
                      item.IsFavorite
                    );
                    return {
                      ...item,
                      Matches: item.Matches.map((match) => {
                        this.favoritesService.checkFavoriteMatch(
                          match.Id,
                          match.IsFavorite
                        );
                        return match;
                      }),
                    };
                  }),
          };
        }),
        catchError((error) => {
          this.isLoadingSoccerMatches.set(false);
          this.soccerMatches.set([]);
          this.isErrorSoccerMatches.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        console.log({ data });
        this.isLoadingSoccerMatches.set(false);
        if (!data) return;

        if (data.Competitions !== null) {
          this.soccerMatches.update((prev) => [...prev, ...data.Competitions]);
        } else {
          this.soccerMatches.set([]);
        }
        const { Competitions, ...rest } = data;
        this.counterMatches.set({ ...rest });
        this.paginationMatches.set(page);
        this.totoalPageMatches.set(data.TotalPages);

        // google tag
        // this.googleTagAnalyticsService.event(
        //   EGoogleTagAnalyticsKeys.VIEW_HOME,
        //   {
        //     competitions_count: Competitions.length,
        //     competitions: Competitions,
        //     live_matches_count: rest.LiveMatches,
        //   }
        // );
      });
  }

  clearSoccerMatches() {
    this.soccerMatches.set([]);

    this.paginationMatches.set(0);
  }

  callEndpintByDateClick() {
    this.clearSoccerMatches();
    this.getCompetitionMatchesFavorites(1);
  }
}
